import React from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import PublicIcon from "@material-ui/icons/Public";
import styled from "styled-components";
import { useSnackbar } from "../../../../app/contexts/snackbar.context";
import { useStudyPlan } from "../../../../app/contexts/study.context";
import { useUser } from "../../../../app/contexts/user.context";
import PrimaryButton from "../../../../app/components/buttons/primary";
import OutlinedButton from "../../../../app/components/buttons/outlined";
import TextButton from "../../../../app/components/buttons/text";
import { validateSeasonalVariations } from "../../validations/validate.study.plan";

const BottomControls = ({ errors, warnings }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id, planId } = useParams();
  const {
    runSimulation,
    studyPlan,
    validateSequentialCohort,
    isSequential,
  } = useStudyPlan();
  const { scenarioStatus } = studyPlan;
  const { showSnackbar } = useSnackbar();
  const { isReadOnlyUser } = useUser();

  const handleBack = () =>
    navigate(`/ctpo/study-plans/${id}/${planId}/countries-and-site-groups`);

  const handleRunSimulation = () => {
    if (scenarioStatus === "Draft" && !isReadOnlyUser) {
      const seqValid = isSequential
        ? validateSequentialCohort(location.pathname)
        : true;
      const { seasonalValid } = validateSeasonalVariations(studyPlan);
      if (Object.keys(warnings || {}).length !== 0) {
        showSnackbar(
          <ul>
            {Object.keys(warnings || {}).map((key) => {
              if (key !== "BUTTON_TYPE") return <li>{warnings[key]}</li>;
              return null;
            })}
          </ul>,
          "warning",
        );
      }
      if (Object.keys(errors || {}).length !== 0 ||
        !seqValid ||
        !seasonalValid
      ) {
        showSnackbar(
          <ul>
            {Object.keys(errors || {}).map((key) => {
              if (key !== "BUTTON_TYPE") return <li>{errors[key]}</li>;
              return "";
            })}
            {!seqValid && <li>Sequential cohorts setup is not valid</li>}
            {!seasonalValid && (
              <li>Country enrollment seasonal variations are not valid</li>
            )}
          </ul>,
          "error",
        );
        return;
      }
      runSimulation();
    }
    navigate(
      isReadOnlyUser
        ? `/ctpo/study-plans/${id}/${planId}/simulation?type=view`
        : `/ctpo/study-plans/${id}/${planId}/simulation`
    );
  };

  let simulationButtonLabel = "";
  if (isReadOnlyUser) {
    simulationButtonLabel = "View Simulation";
  } else {
    if (scenarioStatus === "Draft") {
      simulationButtonLabel = "Finish & Run Simulation";
    } else {
      simulationButtonLabel = "Finish & View Simulation";
    }
  }

  return (
    <div>
      <Container>
        <TextButton
          onClick={() =>
            window.scrollTo({
              top: 0,
              behavior: "smooth",
            })
          }
        >
          <PublicIcon />
          View Different Country
        </TextButton>
      </Container>
      <Container>
        {!isReadOnlyUser && <OutlinedButton onClick={handleBack}>Back</OutlinedButton>}
        {(!isReadOnlyUser || (isReadOnlyUser && scenarioStatus !== "Draft")) && (
          <PrimaryButton onClick={handleRunSimulation}>
            {simulationButtonLabel}
          </PrimaryButton>
        )}
      </Container>
    </div>
  );
};

export default BottomControls;

const Container = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: 1em 0;
  gap: 1em;
`;
